"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var highlightNodeContent_1 = __importDefault(require("../lib/highlightNodeContent"));

var unescape_1 = __importDefault(require("../lib/unescape"));
/**
 * Highlight `words` in `subject`.
 */


var browser = function browser(subject, words) {
  if (words === void 0) {
    words = [];
  }

  if (words.length === 0) {
    if (subject instanceof HTMLElement) {
      return subject.outerHTML;
    }

    return subject;
  }

  var el;

  if (subject instanceof HTMLElement) {
    el = subject;
  } else {
    // Create a DOM element here so we can detect and properly highlight HTML
    // inside the `subject` argument.
    el = document.createElement('div');
    el.innerHTML = subject;
  } // Highlight the content in the new node.


  var highlighted = highlightNodeContent_1.default(el, words);

  if (typeof subject === 'string') {
    return unescape_1.default(highlighted.innerHTML);
  }

  return highlighted.outerHTML;
};

exports.default = browser;